/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type { SubmitFeedbackPathParameters, TouchpointVersionFeedbackRequest } from "../schemas";

import { customInstance } from "../../config/mutator";

export const getTouchpointVersionFeedback = () => {
  /**
 * Submit or change thumbs up/down feedback on an AI-generated touchpoint version

Required authority: PERM_TOUCHPOINT_WRITE
 */
  const submitFeedback = (
    { clientId, campaignId, touchpointId, versionId }: SubmitFeedbackPathParameters,
    touchpointVersionFeedbackRequest: TouchpointVersionFeedbackRequest,
  ) => {
    return customInstance<void>({
      url: `/api/clients/${clientId}/campaigns/${campaignId}/touchpoints/${touchpointId}/versions/${versionId}/feedback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: touchpointVersionFeedbackRequest,
    });
  };
  return { submitFeedback };
};
export type SubmitFeedbackResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getTouchpointVersionFeedback>["submitFeedback"]>>
>;
